import styled from 'styled-components';

import type { JobBookmarkState } from '@xing-com/crate-common-graphql-types';
import { JobUserXingApplicationStatus } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import type { JobDetails } from '@xing-com/crate-jobs-helpers';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

import { ShareJobProvider } from '../../../hooks';

import { BookmarkButton } from './bookmark-button';
import { MoreMenuButton } from './more-menu-button';

const ActionsContainer = styled.div`
  display: none;

  @media ${mediaConfined} {
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${spaceL};
  }

  @media print {
    display: none;
  }
`;

type Props = {
  applicationStatus?: JobUserXingApplicationStatus;
  bookmarkState?: JobBookmarkState;
  isHeaderSticky: boolean;
  job: JobDetails;
};

export const TopActions: React.FC<Props> = ({
  applicationStatus,
  bookmarkState,
  isHeaderSticky,
  job,
}) => {
  const { isLoggedIn } = useLoginState();

  const hasApplied =
    applicationStatus === JobUserXingApplicationStatus.Success ||
    applicationStatus === JobUserXingApplicationStatus.Pending;
  const showMoreMenuButton = (hasApplied || !isHeaderSticky) && isLoggedIn;
  const showBookmarkButton = hasApplied && isLoggedIn;

  if (!showMoreMenuButton && !showBookmarkButton) {
    return null;
  }

  return (
    <ActionsContainer>
      {showMoreMenuButton ? (
        <ShareJobProvider globalId={job.globalId} url={job.url}>
          <MoreMenuButton iconOnly job={job} />
        </ShareJobProvider>
      ) : null}
      {showBookmarkButton ? (
        <BookmarkButton
          bookmarkState={bookmarkState}
          job={job}
          size="small"
          sizeConfined="medium"
          variant="onColor"
          iconOnly
        />
      ) : null}
    </ActionsContainer>
  );
};
